import { z } from "zod";

export const financeSyncSchema = z.object({
  date: z.iso.date(), company: z.string(),
  phase: z.enum(["running", "complete", "failed"]), message: z.string(),
  startedAt: z.iso.datetime(), finishedAt: z.iso.datetime().nullable(),
});
export type FinanceSync = z.infer<typeof financeSyncSchema>;
